
import naxxumhrcalander from "./components/Calendar.vue";
export default{
  install(Vue){
    Vue.component("naxxumhrcalander", naxxumhrcalander);

  }
};



